<template>
  <div class="card p-3">
    <h4 slot="header" class="card-title">Configurações Globais</h4>
    <b-form class="d-flex">
      <b-form-group id="a" label="Limite de Budget diário por pessoa" label-for="appBudget">
        <money class="form-control" id="appBudget" v-model="appBudget" v-bind="money" style="max-width: 100px"></money>
      </b-form-group>
      <b-form-group class="d-flex align-self-end">
        <hr style="width: 25px; transform: rotate(90deg); align-self: center; border-color: #2b3553" />
      </b-form-group>
      <b-form-group label="Dias para expiração das respostas" label-for="daysExpiration">
        <b-form-input class="form-control" style="max-width: 100px" id="daysExpiration" v-model="daysToExpiration" placeholder="Dias" type="number" min="30" required></b-form-input>
      </b-form-group>
      <b-form-group> </b-form-group>
    </b-form>
    <b-button @click="updateConfig(appBudget, daysToExpiration)" id="updateButton" type="button" class="btn btn-primary w-25"> Atualizar </b-button>
  </div>
</template>
<script>
import { Money } from 'v-money';
import api from '@/api.js';
export default {
  components: {
    Money,
  },
  data() {
    return {
      daysToExpiration: 30,
      appBudget: 1,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    async loadConfig() {
      const { data } = await api.get('/configs');
      this.appBudget = Number(data['app-budget']);
      this.daysToExpiration = data['response-valid-until-days'];
    },
    async updateConfig(appBudgetNumber, daysToExpiration) {
      const appBudget = appBudgetNumber.toString();
      const data = {
        'app-budget': appBudget,
        'response-valid-until-days': daysToExpiration,
      };
      try {
        await api.put('/configs/', data);
        this.$notify({
          icon: 'tim-icons icon-bell-55',
          type: 'success',
          timeout: 3000,
          message: 'Alteração realizada com sucesso',
        });
      } catch (error) {
        this.$notify({
          icon: 'tim-icons icon-bell-55',
          type: 'danger',
          timeout: 3000,
          message: error.response.data.error,
        });
      }
      this.loadConfig();
    },
  },
  mounted() {
    this.loadConfig();
  },
};
</script>
<style></style>
